<template>
    <el-switch
        v-model="switchStatus"
        :active-value="0"
        :inactive-value="1"
        :active-text="activeText"
        size="small"
        style="--el-switch-on-color: var(--el-color-primary); --el-switch-off-color: rgba(194, 204, 217, 0.5)"
        @change="pushId(row)"
    />
</template>

<script lang="ts" setup>
import { columns } from 'element-plus/es/components/table-v2/src/common';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const i18n = useI18n();
const props = defineProps({
    row: {
        type: Object,
        default: () => ({})
    },
    column: {
        type: Object,
        default: () => ({})
    }
});
const emits = defineEmits(['handleClick']);
const switchStatus = ref(props.row.dstatus);
const activeText = computed(() => switchStatus.value === 0 ? i18n.t('settings.switchOpen') : i18n.t('settings.switchClose'));
const pushId = (row: any) => {
    if (row.dstatus === 0) {
        row.dstatus = 1;
    } else {
        row.dstatus = 0;
    }
    emits('handleClick', {
        row,
        funName: props.column.changeStatus
    });
};
watch(() => props.row.dstatus, (val, oldVal) => {
    switchStatus.value = val;
});

</script>

<style lang="scss" scoped>

</style>
